import { useState, useEffect } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';

import { useTranslation } from "react-i18next";
import { getTimestampToDate, parseLocaleDatetime } from "../../../common/util";
import { IngressData } from "./IngressData";
import { requests } from "common/RestAPI";
import { PLATFORM_URL } from "value/Url";
import { TextArea } from "components/base/CustomInputText";
import CodeEditor, { SelectionText } from "@uiw/react-textarea-code-editor";

interface IngresssUpdateProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: IngressData,
};

IngresssUpdate.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function IngresssUpdate(props:IngresssUpdateProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeUpdateYn, setExecuteUpdateYn] = useState(false);
    const [ingressDesc, setIngressDesc] = useState("");
    const [ingressYaml, setIngressYaml] = useState("");
    const [ingressYamlWarnYn, setIngressYamlWarnYn] = useState(false);


    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);

    useEffect(() => {
        if(stepIndex === 0) {
        }
    }, [stepIndex])

    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {

                }
            } else {
                const successYn = checkIngressData();
                if(successYn) {
                    setExecuteUpdateYn(true);
                } else {
                    executeResult({successYn: false}, false, '');
                }
                
            }

        }
    }, [props.clickedConfirmYn]);


    useEffect(() => {
        if(executeUpdateYn) {
            executeUpdateIngress();
        }
    }, [executeUpdateYn]);

    useEffect(() => {
        if(stepIndex === 0) {
            loadIngress();
        }
    }, [stepIndex]);


    function loadIngress() {
        requests.get(PLATFORM_URL.INGRESS + '/' + props.args?.ingress_id)
        .then((response) => {
            setIngressYaml(response.data.ingress_yaml);
            setIngressDesc(response.data.ingress_description);
        })
        .catch((error) => {
            executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
        });
    }

    function executeResult(result, closeYn, infoMessage) {
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }

    function checkIngressData() {
        setIngressYamlWarnYn(false);
        let message = "";
        let error = false;
        if(!ingressYaml) {
            message = t("MESSAGE_INGRESS_YAML_INFO_ENTER_ERROR_MESSAGE");
            setIngressYamlWarnYn(true);
            error = true;
        }
        if(error == true)
            if(props.showMessageCb){
                props.showMessageCb(message);
        }
        return !error;
    }


    function executeUpdateIngress() {
        const updatePackageData = {
            ingress: {
                ingress_description: ingressDesc,
            },
            ingress_yaml: ingressYaml
        };

        requests.put(PLATFORM_URL.INGRESS + '/' + props.args?.ingress_id, updatePackageData)
        .then((response) => {
            executeResult({successYn: true }, true, "");
        })
        .catch((error) => {
            executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
        });
    }
    
    return (
        <View>
            {
                stepIndex === 0 ?
                // 이름, 설명, 사용 유형, 사용 대상
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("POD_SERVICE_UPDATE_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("NAME_TEXT")}
                            </Text>
                            <Text style={style.dataText}>
                                {props.args?.ingress_name}
                            </Text>
                        </View>
                        <View style={style.rowTopAlignContainer}>
                            <Text style={style.columnText}>
                                {t("DESCRIPTION_TEXT")}
                            </Text>
                            <TextArea
                                key={2}
                                width={570} height={100}
                                value={ingressDesc}
                                type={"text"}
                                activeYn={true}
                                inputCb={setIngressDesc}
                                warnYn={false}
                                placeHolderText={t("DESCRIPTION_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowDivContainer}/>
                    </View>
                    <Text style={{...style.titleText, marginTop: 15}}>{
                        t("INGRESS_YAML_DESCRIPTION_TEXT")}
                    </Text>
                    <View style={{...style.mainContainer, marginTop: 15}}>
                        <View style={style.rowTopAlignContainer}>
                            <View style={style.rowTopAlignContainer}>
                                <CodeEditor
                                    value={ingressYaml}
                                    language="yaml"
                                    onChange={(evn) => setIngressYaml(evn.target.value)}
                                    padding={15}
                                    contentEditable={true}
                                    style={{
                                        borderRadius: 8,
                                        fontSize: 12,
                                        width: 720,
                                        background: '#fafafa'
                                    }}
                                />
                            </View>
                        </View>
                    </View>
                </View>
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",
    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    dataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    infoText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#8c8c8c"
    },
    dateTitleText: {
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#8793a3"
    },
    dateText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#9ea0a5"
    },
    
});